export const convertToTitleCase = (text) => {
  if (text) {
    return text
      .toLowerCase()
      .replace(/\b[a-z]/g, (firstLetter) => firstLetter.toUpperCase());
  }

  return "";
};
